import { useEffect, useState } from 'react'

export const useWindowScrollPosition = () => {
  const [isAtTop, setIsAtTop] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const isScrollLocked =
        document.body.style.position === 'fixed' || document.body.getAttribute('modalOpen') === 'true'

      if (isScrollLocked) return

      setIsAtTop(window.scrollY <= 0)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return isAtTop
}
